import {getAccessToken} from "../storage/accessTokenStorage";
import {doFileUpload} from "../../actions/thunks/schemaThunks";

const fileUpload = (component, file, property) => {
  let accessToken = component.props.accessToken ? component.props.accessToken : getAccessToken();
  component.props.dispatch(doFileUpload(file, accessToken, component.props.uploadEndpoint, component.props.id, property));
};

export default fileUpload;